import { eventChannel } from 'redux-saga'
import { fork, put, takeEvery } from 'redux-saga/effects'

import history from 'browserHistory'

import * as actions from './actions'
import { sendPageViewData } from 'helpers/analytics'
import { supportedRoutes } from 'pages'

function createRouteChannel() {
  const channel = eventChannel(emitter => {
    const listener = history.listen((location, action) => {
      emitter(actions.changed({ location, action }))
    })

    return listener
  })

  return channel
}

function* routeChangedWorker({ payload }: ActionType) {
  yield put(actions.changed(payload))
  const storeIDRegex = /(\/detail)\/([0-9])*/
  if (
    payload.location.pathname === supportedRoutes.home ||
    storeIDRegex.test(payload.location.pathname)
  ) {
    sendPageViewData()
  }
}

function* RoutesSaga() {
  yield fork(routeChangedWorker, actions.changed(history))
  const routeChannel = createRouteChannel()
  yield takeEvery(routeChannel, routeChangedWorker)
}

export default RoutesSaga
